import { Cache } from "@siteimprove/alfa-cache";
import { Element, Node } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Refinement } from "@siteimprove/alfa-refinement";
import { Context } from "@siteimprove/alfa-selector";
import { Style } from "@siteimprove/alfa-style";
const { hasAttribute, isElement } = Element;
const { or, equals } = Predicate;
const { and } = Refinement;
const { hasComputedStyle } = Style;
/**
 * Check if an element is programmatically hidden.
 *
 * While this only uses Style properties, this is thematically related to
 * accessibility and aria-* attributes and therefore lives in alfa-aria.
 *
 * @public
 */
export function isProgrammaticallyHidden(device, context = Context.empty()) {
    return or(hasComputedStyle("visibility", (visibility) => visibility.value !== "visible", device, context), hasHiddenAncestors(device, context));
}
const hasHiddenAncestors = Cache.memoize(function (device, context) {
    return or(
    // Either it is a programmatically hidden element
    and(isElement, or(hasComputedStyle("display", ({ values: [outside] }) => outside.value === "none", device, context), hasAttribute("aria-hidden", equals("true")))), 
    // Or its parent is programmatically hidden
    (node) => node.parent(Node.fullTree).some(hasHiddenAncestors(device, context)));
});
//# sourceMappingURL=is-programmatically-hidden.js.map